export interface EmailTemplate {
  type: string;
  subject: string;
  contentHtml: string;
  contentPlainText: string;
  fromName: string;
  fromEmail: string;
  bccEmailTo: string;
}

/** Friendly names for the template types the editor exposes. */
export const EmailTemplateNames: { [type: string]: string } = {
  UserNew: "New user activation",
  UserUpdated: "User profile updated",
  UserForgotPassword: "Password reset",
  UserChangedUsername: "Username changed",
  UserImportResults: "Import results (to admin)",
  AttendeesEmail: "Email to all attendees (default content)",
  UserLoginCode: "Sign-in code",
};

/** Placeholders replaced per recipient when an email is sent. */
export const EmailPlaceholders: { token: string; description: string }[] = [
  { token: "[[UserTitle]]", description: "Title (with trailing space, empty if none)" },
  { token: "[[UserFirstname]]", description: "First name" },
  { token: "[[UserLastname]]", description: "Last name" },
  { token: "[[UserUsername]]", description: "Username (email)" },
  { token: "[[UserEmail]]", description: "Email address" },
  { token: "[[ResetPasswordLink]]", description: "Password reset link (reset emails only)" },
  { token: "[[LoginCode]]", description: "6-digit sign-in code (sign-in code emails only)" },
  { token: "[[SystemUrl]]", description: "The portal address, e.g. adom.synod.link" },
  { token: "[[SystemHelpEmail]]", description: "The synod help email address" },
  { token: "[[DateTimeNow]]", description: "Current date and time" },
];
